<div class="pickup-container position-relative text-center">
  <img
    src="/assets/img/resources/ship-a-box/ship-a-box-banner.jpg"
    alt=""
    class="img-fluid"
  />

  <button
    class="btn btn-success schedule-btn text-white"
    [routerLink]="['/booking']"
  >
    Schedule Your Box Here!
  </button>
</div>

<!-- BOXES -->
<div class="box-size container">
  <div class="text-center mb-5">
    <h1 class="fw-bold display-5 text-success section-title">BOX SIZES</h1>
    <p class="fs-5">Choose the perfect box size for your shipping needs</p>
  </div>
  <div class="row g-4">
    <!-- DOYDOY BOX -->
    <div class="col-lg-4 col-md-6">
      <div class="card box-card h-100 shadow-sm">
        <div class="card-img-top-wrapper">
          <img
            src="/assets/img/boxes/doydoy-box.png"
            alt="DOYDOY BOX"
            class="card-img-top box-image"
            loading="lazy"
          />
        </div>
        <div class="card-body d-flex flex-column">
          <h4 class="card-title fw-bold text-success mb-2">DOYDOY BOX</h4>
          <h6 class="card-subtitle mb-3 fw-semibold">24 x 18 x 24 Inches</h6>
          <p class="card-text flex-grow-1">
            The biggest boxes we offer, perfect for large items.
          </p>
          <div class="mt-auto">
            <span class="badge bg-primary-subtle text-primary">Large Size</span>
          </div>
        </div>
      </div>
    </div>

    <!-- POP BOX -->
    <div class="col-lg-4 col-md-6">
      <div class="card box-card h-100 shadow-sm">
        <div class="card-img-top-wrapper">
          <img
            src="/assets/img/boxes/pop-box.png"
            alt="POP BOX"
            class="card-img-top box-image"
            loading="lazy"
          />
        </div>
        <div class="card-body d-flex flex-column">
          <h4 class="card-title fw-bold text-success mb-2">POP BOX</h4>
          <h6 class="card-subtitle mb-3 fw-semibold">23 x 17.5 x 20 Inches</h6>
          <p class="card-text flex-grow-1">
            Our standard box perfect for regular shipments to the Philippines.
          </p>
          <div class="mt-auto">
            <span class="badge bg-success-subtle text-success">Standard</span>
          </div>
        </div>
      </div>
    </div>

    <!-- ALI BOX -->
    <div class="col-lg-4 col-md-6">
      <div class="card box-card h-100 shadow-sm">
        <div class="card-img-top-wrapper">
          <img
            src="/assets/img/boxes/ali-box.png"
            alt="ALI BOX"
            class="card-img-top box-image"
            loading="lazy"
          />
        </div>
        <div class="card-body d-flex flex-column">
          <h4 class="card-title fw-bold text-success mb-2">ALI BOX</h4>
          <h6 class="card-subtitle mb-3 fw-semibold">17 x 7 x 7 Inches</h6>
          <p class="card-text flex-grow-1">
            Our smallest box, perfect for small items and gifts.
          </p>
          <div class="mt-auto">
            <span class="badge bg-info-subtle text-info">Small Size</span>
          </div>
        </div>
      </div>
    </div>

    <!-- HANNAH BOX -->
    <div class="col-lg-4 col-md-6">
      <div class="card box-card h-100 shadow-sm">
        <div class="card-img-top-wrapper">
          <img
            src="/assets/img/boxes/hannah-box.png"
            alt="HANNAH BOX"
            class="card-img-top box-image"
            loading="lazy"
          />
        </div>
        <div class="card-body d-flex flex-column">
          <h4 class="card-title fw-bold text-success mb-2">HANNAH BOX</h4>
          <h6 class="card-subtitle mb-3 fw-semibold">23 x 17 x 10 Inches</h6>
          <p class="card-text flex-grow-1">
            Perfect for flat items and documents with a lower profile.
          </p>
          <div class="mt-auto">
            <span class="badge bg-warning-subtle text-warning">Flat size</span>
          </div>
        </div>
      </div>
    </div>

    <!-- TRAVEL BOX -->
    <div class="col-lg-4 col-md-6">
      <div class="card box-card h-100 shadow-sm">
        <div class="card-img-top-wrapper">
          <img
            src="/assets/img/boxes/travel-box.png"
            alt="TRAVEL BOX"
            class="card-img-top box-image"
            loading="lazy"
          />
        </div>
        <div class="card-body d-flex flex-column">
          <h4 class="card-title fw-bold text-success mb-2">TRAVEL BOX</h4>
          <h6 class="card-subtitle mb-3 fw-semibold">21 x 14 x 20 Inches</h6>
          <p class="card-text flex-grow-1">
            Compact and sturdy box ideal for travel essentials and personal
            items.
          </p>
          <div class="mt-auto">
            <span class="badge bg-secondary-subtle text-secondary"
              >Travel Size</span
            >
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<div class="process-container">
  <div class="container">
    <!-- Header -->
    <div class="text-center">
      <h1 class="fw-bold display-5 text-success section-title">
        YOUR BALIKBAYAN BOX JOURNEY
      </h1>
      <p class="fs-5">
        Understanding how your Balikbayan box travels from overseas to your
        loved ones in the<br />
        Philippines through our comprehensive shipping process.
      </p>
    </div>

    <!-- Featured Step -->
    <div class="row justify-content-center mb-5">
      <div class="col-lg-10">
        <div class="featured-step">
          <div class="row align-items-center">
            <div class="col-lg-8">
              <div class="text-primary fw-semibold mb-2">
                STEP {{ processSteps[activeStep].id }}
              </div>
              <h3 class="fw-semibold mb-3">
                {{ processSteps[activeStep].title }}
              </h3>
              <p class="mb-0">
                {{ processSteps[activeStep].description }}
              </p>
            </div>
            <div class="col-lg-4 text-end">
              <div
                class="step-icon mx-auto"
                [ngClass]="processSteps[activeStep].color"
                style="width: 6rem; height: 6rem; font-size: 3rem"
              >
                <!-- <i class="{{ processSteps[activeStep].icon }}"></i> -->
                <img src="{{ processSteps[activeStep].icon }}" alt="" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Process Flow -->
    <div class="row justify-content-center">
      <div class="col-lg-10 position-relative">
        <div class="timeline-line d-none d-lg-block"></div>
        <div class="row" *ngFor="let step of processSteps; let i = index">
          <div
            class="col-lg-6"
            [ngClass]="{ 'offset-lg-6': step.position === 'right' }"
          >
            <div
              class="timeline-dot d-none d-lg-block"
              [ngClass]="getTimelineDotClasses(i)"
            >
              <div
                *ngIf="isActive(i)"
                class="position-absolute top-50 start-50 translate-middle bg-white rounded-circle"
                style="width: 0.5rem; height: 0.5rem"
              ></div>
            </div>

            <div
              class="step-card"
              [ngClass]="getStepCardClasses(i)"
              (click)="setActiveStep(i)"
            >
              <div class="d-flex align-items-center">
                <div class="step-icon me-4" [ngClass]="getStepIconClasses(i)">
                  <!-- <i class="{{ step.icon }}"></i> -->
                  <img src="{{ step.icon }}" alt="" class="step-image" />
                </div>
                <div class="flex-grow-1">
                  <div
                    class="text-uppercase fw-bold mb-1"
                    style="font-size: 0.75rem"
                    [ngClass]="getStepTextClasses(i)"
                  >
                    STEP {{ step.id }}
                  </div>
                  <h5
                    class="fw-bold mb-2 fs-5"
                    [ngClass]="isActive(i) ? 'text-danger' : 'text-success'"
                  >
                    {{ step.title }}
                  </h5>
                  <p class="mb-0">{{ step.description }}</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Progress Bar -->
    <div class="row justify-content-center mt-5">
      <div class="col-lg-8">
        <div class="progress-bar-container">
          <div class="text-center mb-4">
            <h4 class="fw-bold">Process Overview</h4>
            <p class="">Complete step-by-step shipping journey</p>
          </div>
          <div class="custom-progress-bar mb-4">
            <div
              class="progress-fill"
              [style.width.%]="getProgressPercentage()"
            >
              <div class="progress-thumb"></div>
            </div>
          </div>
          <div class="text-center">
            <h5 class="fw-bold">{{ processSteps[activeStep].title }}</h5>
            <p class="small">
              {{ processSteps[activeStep].description }}
            </p>
          </div>
        </div>
      </div>
    </div>

    <!-- Navigation Buttons -->
    <div class="step-navigation">
      <button
        *ngFor="let step of processSteps; let i = index"
        class="nav-button"
        [ngClass]="getNavButtonClasses(i)"
        (click)="setActiveStep(i)"
      >
        {{ step.id }}
      </button>
    </div>

    <!-- Timeline Info -->
    <div class="row justify-content-center mt-5">
      <div class="col-lg-10">
        <div class="timeline-info">
          <h2 class="text-center fw-bold mb-4 text-white">
            Typical Processing Timeframes
          </h2>
          <div class="row g-3">
            <div
              class="col-md-3 col-6"
              *ngFor="
                let info of [
                  { value: '2-3', unit: 'Days', text: 'Warehouse Processing' },
                  { value: '4-6', unit: 'Weeks', text: 'Sea Freight' },
                  { value: '2-6', unit: 'Days', text: 'Customs Clearance' },
                  { value: '2-4', unit: 'Days', text: 'Local Delivery' }
                ]
              "
            >
              <div class="timeline-box text-center">
                <div class="display-6 fw-bold">{{ info.value }}</div>
                <div class="small">{{ info.unit }}</div>
                <div style="font-size: 0.75rem" class="mt-2">
                  {{ info.text }}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<div class="container-fluid hero-section py-5">
  <div class="container text-center">
    <div class="mb-3">
      <h1 class="fw-bold display-5 text-success section-title">
        WHY SHIP WITH LOGO
      </h1>
    </div>
    <div class="row justify-content-center">
      <div class="col-lg-6">
        <div class="row g-4">
          <div class="col-md-6" *ngFor="let feature of features; let i = index">
            <div
              class="feature-card h-100"
              [class.feature-hovered]="hoveredFeature === i"
              (mouseenter)="onFeatureHover(i)"
              (mouseleave)="onFeatureLeave()"
            >
              <div class="card border-0 h-100 shadow-sm">
                <div class="card-body p-4">
                  <div class="d-flex align-items-start">
                    <div
                      [class]="'feature-icon ' + feature.colorClass + ' me-3'"
                    >
                      <i [class]="feature.icon"></i>
                    </div>
                    <div class="flex-grow-1">
                      <div class="d-flex align-items-center mb-2">
                        <h6 class="card-title mb-0 me-2">
                          {{ feature.title }}
                        </h6>
                        <i class="bi bi-check-circle-fill text-success"></i>
                      </div>
                      <p class="card-text small mb-0">
                        {{ feature.description }}
                      </p>
                    </div>
                  </div>
                </div>
                <div
                  class="feature-overlay"
                  [class]="feature.colorClass + '-overlay'"
                ></div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div
        class="col-lg-6 d-flex justify-content-center align-items-center mt-4"
      >
        <img src="/assets/img/boxes/download-mobile-app.png" alt="" />
        <!-- <div class="row">
          <div class="col-lg-6">
            <img
              src="/assets/img/badge/download-qr.png"
              class="download-mobile-app"
              alt=""
            />
          </div>

          <div class="col-lg-6">
            <img
              src="/assets/img/badge/download-logo.png"
              class="logo-img mb-3"
              alt="App Logo"
            />
            <div class="mb-2">
              <img
                src="/assets/img/badge/download-app-store.png"
                class="store-btn"
                alt="App Store"
              />
            </div>
            <div>
              <img
                src="/assets/img/badge/download-google-play.png"
                class="store-btn"
                alt="Google Play"
              />
            </div>
          </div>
        </div> -->
      </div>
    </div>
  </div>
</div>
